/* global G */
import { isArr, isNum, isObj, setKey } from 'lib/util'
import { set } from 'lib/sequence/component/state/value'
import { findGroup } from 'lib/util/attachment'

/**
 * Returns the value of the `status` model attribute, regardless of its many possible shapes.
 *
 * @param {Object} status
 * @returns {*|x is number|x is Array|x is Object}
 */
export const getStatusValue = (status) => {
  const cache = status[G.CACHE]
  return (cache && isNum(cache) && cache)
    || (cache && isArr(cache) && cache?.[0]?.key)
    || (cache && isObj(cache) && cache?.key)
}

/**
 * Presets the message field.
 *
 * @param {Gaia.AppModule.Spec} module  current module
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
const presetMessageField = module => async (components, ...args) => {
  const model = module[G.MODEL]
  const { messageField } = components

  const { currentMessage = null } = module[G.STATE]
  const { status, type } = model[G.CHILDREN]
  const currentStatus = getStatusValue(status)

  setKey(currentStatus, 'currentStatus', messageField[G.STATE])
  setKey(type[G.CACHE], 'currentType', messageField[G.STATE])

  // Setting the message text and entering edit mode in case a message is being edited.
  if (currentMessage) {
    if (currentMessage?.value?.attachments?.length) {
      const { [G.EVENTS]: eventBus } = module[G.ADAPTER]

      eventBus.dispatch(
        eventBus.type(G.ATTACHMENT, G.CACHE, findGroup(module, null, 'messageGroup')),
        {
          [G.DATA]: {
            [G.DATA]: currentMessage.value.attachments,
          },
        },
      )
    }
    set(messageField, { text: module[G.STATE].text })
    setKey(true, 'edit', messageField[G.STATE])
  }

  return [components, ...args]
}

export default presetMessageField
